/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Good_Misty_Koala_EditInputs */

const fr_good_misty_koala_edit = /** @type {(inputs: Good_Misty_Koala_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

/**

* @param {Good_Misty_Koala_EditInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const good_misty_koala_edit = /** @type {((inputs?: Good_Misty_Koala_EditInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Good_Misty_Koala_EditInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_good_misty_koala_edit(inputs)
});